import { FC, Fragment, useState, useEffect } from "react";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import CountdownTimer from "../../../components/CountdownTimer/CountdownTimer";
import TableHeaderComponent from "../../../components/TableHeader/TableHeader";
import TablFooter from "../../../components/TableFooter/TableFooter";

import ImageUploader from "../../../components/ImageUploader/ImageUploader";
import FormBuilder from "../../FormBuilder/FormBuilder";
import Button from "../../../components/UI/Button/Button";

import {
  updateFormInputState,
  validateForm,
  updateFormSelectState,
  updateFormTimeState,
  updateFormDate,
  transformGMTToUTC,
  transformDate,
} from "../../../Utility/Utility";
import {
  FormElementType,
  customValidationType,
  InputVariant,
  InputTypes,
  FormElement,
  NotificationType,
} from "../../../Utility/InterFacesAndEnum";

import { adminRouts } from "../../../routs";
import {
  getAuctionDetailById,
  deleteAuction,
  toggleAuctionDeletionState,
  updateAuction,
  cancelAuction,
  toggleAuctionCancelState,
} from "../../../features/auctionList";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import {
  CreateLotteryFirstSection,
  CreateLotterySecondSection,
} from "../../Forms/Lottery/CreateLottery/RepeatedLottery/StyledCreateLottery";
import {
  HeaderView,
  FormContainer,
  FormWrapper,
  FormBody,
  TwoSections,
  ActionBtn,
  WinnerFormBody,
} from "../CreateAuction/StyledCreateAuction";
import {
  StatusContainer,
  StatusBody,
  StatusTitle,
  SectionTitle,
  Value,
  TwoSection,
  CheckboxContainer,
  CheckboxDesc,
  Table,
  EmptyTableBody,
  WinnerStatusBody,
  WinnerStatusTitle,
  WinnerValue,
  UpdateTitle,
} from "./StyledAuctionDetail";
import { RootState } from "../../../app/Store";
import { SelectedCheckbox, EmptyCheckbox } from "./StyledAuctionDetail";

import { validateCreateAuction } from "../../../Utility/formValidation";
import { toggleNotificationVisibility } from "../../../features/networkNotification";
import { resetImages, setImages } from "../../../features/imageUploaderSlice";
import { countryNames } from "../../../assets/images/DropdownValues";
import ActionModal from "../../../components/Modal/ActionModal";
import {
  clearAuctionWinner,
  getAuctionPurchaseTickets,
  setIsAuctionWinner,
  setMannualAuctionWinner,
} from "../../../features/winnerSlice";

class TableHeader {
  constructor(
    public label: string,
    public isSortRequired: boolean,
    public isAscSorted: boolean,
    public isDscSorted: boolean,
    public id: string
  ) {}
}

let winnerDetailTableHeaders = [
  new TableHeader("Users", false, true, false, "users"),
  new TableHeader("Purchase Date", false, false, false, "purchaseDate"),
  new TableHeader("Ticket type", false, false, false, "ticketType"),
  new TableHeader("No Of Tickets", false, false, false, "noOfTickets"),
  new TableHeader("Total amount", false, false, false, "totalAmount"),
];

let purchaseDetailTableHeaders = [
  new TableHeader("Users", true, true, false, "users"),
  new TableHeader("Purchase Date", true, false, false, "purchaseDate"),
  new TableHeader("Ticket type", false, false, false, "ticketType"),
  new TableHeader("No Of Tickets", false, false, false, "noOfTickets"),
  new TableHeader("Total amount", true, false, false, "totalAmount"),
];

interface FormState {
  form: FormElement[];
  isValidForm: boolean;
}

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

const AuctionDetail: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "auctionTitle",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.titleValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Title",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.textArea,
      value: "",
      id: "auctionDesc",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.descriptionValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Description (Optional)",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "auctionPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.priceValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Auction Price",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "auctionProposedPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.priceValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Proposed Price",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const ScheduleDays: FormState = {
  form: [
    {
      elementType: FormElementType.datePicker,
      value: "",
      id: "auctionStartDate",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.date,
      customValidationType: customValidationType.null,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Start Date",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.datePicker,
      value: "",
      id: "auctionEndDate",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.date,
      customValidationType: customValidationType.null,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "End Date",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const AddressDetails: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "address",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.adressValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Location",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "city",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.cityStateValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "city",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "state",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.cityStateValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "State",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.select,
      value: "",
      id: "country",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.null,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Country",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [...countryNames],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "pincode",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.zipValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Pin/Zip code",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const UserDetails: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "userName",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.nameValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Name",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "userMobile",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.mobileValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Mobile Number",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "userEmailId",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.email,
      customValidationType: customValidationType.emailValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Email",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const TicketDetail: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "bronzeTicketPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Bronze",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "silverTicketPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Silver",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "goldTicketPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Gold",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "platinumTicketPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Platinum",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
  ],
  isValidForm: true,
};

const subTicketDetails: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "bronzeSubTickets",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "No. of Sub Tickets",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "silverSubTickets",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "No. of Sub Tickets",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "goldSubTickets",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "No. of Sub Tickets",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "platinumSubTickets",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "No. of Sub Tickets",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: true,
    },
  ],
  isValidForm: true,
};

const productDetails: FormState = {
  form: [
    {
      elementType: FormElementType.select,
      value: "",
      id: "productType",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.characterValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Type",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [
        "select",
        "Vehicles",
        "Homes and Real Estate",
        "Art and Collectibles",
        "Jewelry and Watches",
        "Tech and Innovation",
        "Others",
      ],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.select,
      value: "",
      id: "productCategory",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: false,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.characterValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Category",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [
        "select",
        "Car",
        "Aircraft",
        "Boats",
        "Home",
        "Real Estate",
        "Art",
        "Collectibles",
        "Jewelry",
        "Watch",
        "Tech",
        "Innovation",
        "Other",
      ],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const winnerStatusForm: FormState = {
  form: [
    {
      elementType: FormElementType.autocomplete,
      value: "",
      id: "winnerTicket",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Select Tickets",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: false,
};

interface winnerTicketProp {
  ticket: string;
  isWinner: boolean;
}

const CreateAuction: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auctionId } = useParams();
  const [imageArray, setImageArray] = useState<any>([]);

  const [auctionDetail, setauctoinDetail] = useState<FormState>(AuctionDetail);
  const [scheduleDetail, setScheduleDetail] = useState<FormState>(ScheduleDays);
  const [addressDetail, setAddressDetail] = useState<FormState>(AddressDetails);
  const [userDetail, setUserDetail] = useState<FormState>(UserDetails);
  const [ticketdetail, setTicketDetail] = useState<FormState>(TicketDetail);
  const [subTicketDetail, setSubTicketDetail] =
    useState<FormState>(subTicketDetails);
  const [productDetail, setProductDetails] =
    useState<FormState>(productDetails);

  const [winnerStatusValues, setWinnerStatusValues] =
    useState<FormState>(winnerStatusForm);
  const [ticket, setTicket] = useState("");
  const [ticketState, setTicketState] = useState<winnerTicketProp>({
    ticket: "",
    isWinner: false,
  });

  const [isForGoldMembers, setStatus] = useState<boolean>(false);
  const [tableHeaderValues, setTableHeader] = useState(
    winnerDetailTableHeaders
  );
  const [purchaseTableHeaders, setPurchaseTableHeaders] = useState(
    purchaseDetailTableHeaders
  );

  const [openModal, setOpenModal] = useState(false);
  const [openUpdateModal, setUpdateOpenModal] = useState(false);
  const [showWinnerSection, setShowWinnerSection] = useState(false);

  const detailResponse = useSelector(
    (state: RootState) => state.auction.auctionDetail
  );
  const isAuctionDeleted = useSelector(
    (state: RootState) => state.auction.isAuctionDeleted
  );
  const isAuctionCanceled = useSelector(
    (state: RootState) => state.auction.isAuctionCanceled
  );
  const { auctionTickets, isWinner, isAuctionWinner } = useSelector(
    (state: RootState) => state.winnerData
  );
  const isLoading=useSelector((state:RootState)=>state.loaderslice.isLoading);
  // console.log(auctionTickets);

  const { images, imageNames } = useSelector(
    (state: RootState) => state.images
  );
  const uniqueImages = [...new Set(imageNames)];

  //   console.log(imageNames)

  // console.log(detailResponse);

  useEffect(() => {
    if (imageArray.length > 0) {
      // window.location.reload();
      dispatch(resetImages());
    }
    if (
      detailResponse.auctionId !== undefined ||
      detailResponse.auctionId !== null
    ) {
      dispatch(
        getAuctionPurchaseTickets({
          auctionId: detailResponse.auctionId,
        })
      );
    }
  }, [detailResponse]);

  useEffect(() => {
    dispatch(getAuctionDetailById(auctionId ? auctionId : ""));
  }, []);

  useEffect(() => {
    if (isAuctionDeleted === true) {
      navigate(adminRouts.auctionList);
    }
    return () => {
      dispatch(
        toggleAuctionDeletionState({
          isDeleted: false,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (isAuctionCanceled === true) {
      navigate(adminRouts.auctionList);
    }
    return () => {
      dispatch(
        toggleAuctionCancelState({
          isCancel: false,
        })
      );
    };
  }, [isAuctionCanceled]);

  useEffect(() => {
    const arr: string[] = [];
    uniqueImages.map((img: string) => {
      const parts = img.split("/");
      const fileName = parts[parts.length - 1];
      // console.log(fileName);
      arr.push(fileName);
    });
    // console.log(arr)
    setImageArray(arr);
  }, [imageNames]);

  useEffect(() => {
    // if (Object.keys(detailResponse).length > 0) {
    let updatedForms = mapAuctionResponse(auctionDetail.form);
    setauctoinDetail({ ...auctionDetail, form: updatedForms });

    let updatedScheduleForm = mapAuctionResponse(scheduleDetail.form);
    setScheduleDetail({
      ...scheduleDetail,
      form: updatedScheduleForm,
    });

    let updatedAddressForm = mapAuctionResponse(addressDetail.form);
    setAddressDetail({ ...addressDetail, form: updatedAddressForm });

    let userDetailForm = mapAuctionResponse(userDetail.form);
    setUserDetail({
      ...userDetail,
      form: userDetailForm,
    });

    let productTypeForm = mapAuctionResponse(productDetail.form);
    setProductDetails({
      ...productDetail,
      form: productTypeForm,
    });

    let ticketsDetailForm = mapAuctionResponse(ticketdetail.form);
    setTicketDetail({
      ...ticketdetail,
      form: ticketsDetailForm,
    });

    let subTickets = mapAuctionResponse(subTicketDetail.form);
    setSubTicketDetail({
      ...subTicketDetail,
      form: subTickets,
    });

    setStatus(detailResponse.isMemberAuction);

    let winnerTickets: any = [];

    if (auctionTickets !== undefined || auctionTickets !== null) {
      auctionTickets.map((ticketObj: any) => {
        winnerTickets.push(ticketObj?.ticketNo);
        if (ticketObj.isWinner === true) {
            setTicketState({
              ticket: ticketObj.ticketNo,
              isWinner: ticketObj.isWinner,
            });
            setTicket(ticketObj?.ticketNo);
          // setIsAuctionWinner({isWinner:true})
        }
      });
    }

    if (winnerTickets.length > 0) {
      let updateWinnerTickets = winnerStatusValues.form.map(
        (ticketObj: any) => {
          return {
            ...ticketObj,
            dropdownValues: [...winnerTickets],
            // Value:winnerTickets[0]
          };
        }
      );
      updateWinnerTickets["value"] = ticketState.ticket;
      setWinnerStatusValues({
        ...winnerStatusValues,
        form: updateWinnerTickets,
      });
    }

    // console.log(updatedAddressForm,'addressDetail')
    // }
  }, [detailResponse, auctionTickets]);

  useEffect(() => {
    if (isAuctionWinner) {
      setTicketState({
        ticket: ticket,
        isWinner: isAuctionWinner,
      });
    } else {
      setTicketState({
        ticket: ticket,
        isWinner: isAuctionWinner,
      });
    }
  }, [isAuctionWinner]);

  useEffect(() => {
    if (Object.keys(detailResponse).length !== 0) {
      // console.log("chalai bho")
      if (detailResponse?.auctionImageUrls !== null) {
        dispatch(
          setImages({
            data: detailResponse?.auctionImageUrls,
            names: detailResponse?.auctionImageUrls,
          })
        );
      }
    }
  }, [detailResponse]);

  const mapAuctionResponse = (formElements: FormElement[]) => {
    let updatedFormElement = formElements.map((element) => {
      let updatedElement = {
        ...element,
      };
      // if (element.elementType === "datePicker") {
      updatedElement["value"] = detailResponse[element.id];
      // }

      return updatedElement;
    });
    return updatedFormElement;
  };

  // ---------- auction detail form ------

  const handleAuctionDetailInput = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, auctionDetail.form);
    setauctoinDetail({
      ...auctionDetail,
      form: updatedStateArray,
    });
  };

  const auctionDetailView = (
    <FormBuilder
      formElements={auctionDetail.form}
      onInputChange={handleAuctionDetailInput}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );

  // ---------- end auction detail --------

  //  ---------- schedule days -------------
  const handleScheduleDaysTimeInput = (date: Date, name: string) => {
    let updatedArray = updateFormDate(date, name, scheduleDetail.form);
    console.log(updatedArray, "updatedArray");
    setScheduleDetail({
      ...scheduleDetail,
      form: updatedArray,
    });
  };

  const scheduleDaysView = (
    <FormBuilder
      formElements={scheduleDetail.form}
      onInputChange={() => {}}
      onSelectValueChange={() => {}}
      onChangeDate={handleScheduleDaysTimeInput}
      onChangeTime={() => {}}
    />
  );

  //  ---------- end schedule days ----------

  //  --------- address details ------------
  const handleAddressState = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, addressDetail.form);
    setAddressDetail({
      ...addressDetail,
      form: updatedStateArray,
    });
  };

  const handleCountryDropdownValueChange = (value: string, name: string) => {
    let updatedArray = updateFormSelectState(value, name, addressDetail.form);
    setAddressDetail({
      ...addressDetail,
      form: updatedArray,
    });
  };

  const addressDetailView = (
    <FormBuilder
      formElements={addressDetail.form}
      onInputChange={handleAddressState}
      onSelectValueChange={handleCountryDropdownValueChange}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );

  // --------- end address details ---------

  //  -------------- user detals -------
  const handleUserDeailState = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, userDetail.form);
    setUserDetail({
      ...userDetail,
      form: updatedStateArray,
    });
  };

  const useDetailView = (
    <FormBuilder
      formElements={userDetail.form}
      onInputChange={handleUserDeailState}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  //  -------------- end user details --------

  //  ------------- ticket details -----------

  const handleTicketDetails = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, ticketdetail.form);
    setTicketDetail({
      ...ticketdetail,
      form: updatedStateArray,
    });
  };

  const ticketDetalView = (
    <FormBuilder
      formElements={ticketdetail.form}
      onInputChange={handleTicketDetails}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  // ------------- end ticket details --------

  //  ---------- subticket details --------
  const handleSubTicketDetails = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, subTicketDetail.form);
    setSubTicketDetail({
      ...subTicketDetail,
      form: updatedStateArray,
    });
  };

  const subTicketDetalView = (
    <FormBuilder
      formElements={subTicketDetail.form}
      onInputChange={handleSubTicketDetails}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  //  ---------- end subticket details --------

  // --------- product details ----------
  const handleProductDetails = (value: string, name: string) => {
    let updatedArray = updateFormSelectState(value, name, productDetail.form);
    setProductDetails({
      ...productDetail,
      form: updatedArray,
    });
  };
  const productDetailView = (
    <FormBuilder
      formElements={productDetail.form}
      onInputChange={() => {}}
      onSelectValueChange={handleProductDetails}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );

  const handleTicketsDropdownValueChange = (value: string, name: string) => {
    let updatedArray = updateFormSelectState(
      value,
      name,
      winnerStatusValues.form
    );
    setTicket(value);
    setWinnerStatusValues({
      ...winnerStatusValues,
      form: updatedArray,
    });
  };

  let AuctionWinnerView = (
    <FormBuilder
      formElements={winnerStatusValues.form}
      onInputChange={() => {}}
      onSelectValueChange={handleTicketsDropdownValueChange}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  // --------- set product details ------

  const deleteAuctionDetails = () => {
    dispatch(deleteAuction(`auctionId=${auctionId}`));
  };

  const validateForm = () => {
    let tempObj = [
      ...auctionDetail.form,
      ...scheduleDetail.form,
      ...addressDetail.form,
      ...userDetail.form,
      ...ticketdetail.form,
      ...subTicketDetail.form,
      ...productDetail.form,
    ];
    let requestObj: any = {};
    for (let element of tempObj) {
      requestObj[element.id] = element.value;
    }
    if (
      requestObj.auctionStartDate.length > 0 &&
      requestObj.auctionEndDate.length > 0
    ) {
      requestObj["auctionStartDate"] = transformGMTToUTC(
        requestObj.auctionStartDate
      );
      requestObj["auctionEndDate"] = transformGMTToUTC(
        requestObj.auctionEndDate
      );

      requestObj["isMemberAuction"] = isForGoldMembers;
    } else {
      requestObj["auctionStartDate"] = "";
      requestObj["auctionEndDate"] = "";
      requestObj["isMemberAuction"] = isForGoldMembers;
    }
    requestObj["auctionImages"] = imageArray;
    requestObj["auctionType"] = detailResponse.auctionType;
    requestObj["auctionId"] = detailResponse.auctionId;

    let validatedObj = validateCreateAuction(requestObj);
    if (validatedObj.status) {
      dispatch(updateAuction(requestObj));
      //   console.log(requestObj)
    } else {
      dispatch(
        toggleNotificationVisibility({
          isVisible: true,
          status: NotificationType.error,
          message: validatedObj.message,
        })
      );
    }
  };

  const triggerCancelAuctionModel = () => {
    setOpenModal(true);
  };

  const confirmCancel = () => {
    dispatch(cancelAuction(detailResponse.auctionId));
    setOpenModal(false);
  };
  const setLotteryWinner = () => {
    if (ticket.length <= 0 || ticket === "") {
      dispatch(
        toggleNotificationVisibility({
          isVisible: true,
          status: NotificationType.error,
          message: "Please Select Ticket.",
        })
      );
    } else {
      setUpdateOpenModal(true);
    }
  };

  const clearLotteryWinnerHandler = () => {
    dispatch(clearAuctionWinner({ auctionId: detailResponse?.auctionId }));
  };
  // console.log(ticketState)

  const setLotteryWinnerHandler = () => {
    dispatch(
      setMannualAuctionWinner({
        auctionId: detailResponse?.auctionId,
        ticketNo: ticket,
      })
    );
    setUpdateOpenModal(false);
  };

  return (
    <Fragment>
      <ActionModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        confirm={confirmCancel}
        title={"Cancel"}
        content={"Auction"}
      />
      <ActionModal
        confirm={setLotteryWinnerHandler}
        openModal={openUpdateModal}
        setOpenModal={setUpdateOpenModal}
        title="Select"
        content="this Ticket."
      />
      <HeaderView>
        <ViewHeader
          // title={"Auction Details"}
          title={`${auctionId}`}
          isBackButtonRequired={true}
          backButtonRedirectionUrl={adminRouts.auctionList}
        />
      </HeaderView>
      <FormContainer>
        <CreateLotteryFirstSection>
          <FormWrapper>
            <SectionTitle>Auction Detail</SectionTitle>
            <FormBody>
              {auctionDetailView}
              {/* <CheckboxContainer
                onClick={() => {
                  setStatus(!isForGoldMembers);
                }}
              >
                {isForGoldMembers ? <SelectedCheckbox /> : <EmptyCheckbox />}
                <CheckboxDesc>For Gold members</CheckboxDesc>
              </CheckboxContainer> */}
            </FormBody>
          </FormWrapper>
          <FormWrapper>
            <SectionTitle>Schedule Days</SectionTitle>
            <FormBody>{scheduleDaysView}</FormBody>
          </FormWrapper>

          <FormWrapper>
            <SectionTitle>Address</SectionTitle>
            <FormBody>{addressDetailView}</FormBody>
          </FormWrapper>
          <ImageUploader />
          
        </CreateLotteryFirstSection>
        <CreateLotterySecondSection>
          <StatusContainer>
            <TwoSection>
              <StatusBody>
                <StatusTitle>Status</StatusTitle>
                <Value>
                  {detailResponse.auctionStatus === "U" ? "Upcoming" :detailResponse.auctionStatus === "C"? "Live":""}
                </Value>
              </StatusBody>
              <StatusBody>
                <StatusTitle>
                  {isLoading||detailResponse.auctionStatus===undefined||detailResponse.auctionStatus===null? "Loading...": detailResponse.auctionStatus === "U"
                    ? "Starts on"
                    : "Ends on"}
                </StatusTitle>
                <Value>
                  {detailResponse.auctionStatus === "U" ? (
                    <CountdownTimer
                      timestamp={new Date(detailResponse.auctionStartDate)}
                    />
                  ) : detailResponse.auctionStatus === "C" ? (
                    <CountdownTimer
                      timestamp={new Date(detailResponse.auctionEndDate)}
                    />
                  ) : (
                    "ended"
                  )}
                </Value>
              </StatusBody>
            </TwoSection>
            <StatusBody>
              <StatusTitle>Auction Type</StatusTitle>
              <Value>
                {detailResponse.auctionType === "A"
                  ? "Admin Created"
                  :detailResponse.auctionType === "U"? "User Created":""}
              </Value>
            </StatusBody>
            <StatusBody>
              <StatusTitle>Visibility</StatusTitle>
              <Value>
                {detailResponse.isMemberAuction===true ? "Gold Members" :detailResponse.isMemberAuction===false? "All Users":""}
              </Value>
            </StatusBody>
            <TwoSection>
              <StatusBody>
                <StatusTitle>Start Date</StatusTitle>
                <Value>{isLoading||detailResponse.auctionEndDate===undefined||detailResponse.auctionEndDate===null?"Loading...": transformDate(detailResponse.auctionStartDate)}</Value>
              </StatusBody>
              <StatusBody>
                <StatusTitle>End Date</StatusTitle>
                <Value>{isLoading ||detailResponse.auctionEndDate===undefined||detailResponse.auctionEndDate===null?"Loading...":transformDate(detailResponse.auctionEndDate)}</Value>
              </StatusBody>
            </TwoSection>
          </StatusContainer>
          <FormWrapper>
            <SectionTitle>Product details</SectionTitle>
            <FormBody>{productDetailView}</FormBody>
          </FormWrapper>

          <FormWrapper>
            <SectionTitle>User Details</SectionTitle>
            <FormBody>{useDetailView}</FormBody>
          </FormWrapper>
          <FormWrapper>
            <SectionTitle>ticket Prices</SectionTitle>
            <TwoSections>
              <FormBody>{ticketDetalView}</FormBody>
              <FormBody>{subTicketDetalView}</FormBody>
            </TwoSections>
          </FormWrapper>

          {detailResponse?.auctionStatus === "C" && (
            <FormWrapper>
              <UpdateTitle show={showWinnerSection}>
                <div>Update</div>
                <Button
                  title={showWinnerSection ? "Hide" : "Show"}
                  btnSize={ButtonSize.md}
                  btnVariant={ButtonVariant.secondary}
                  clicked={() => setShowWinnerSection(!showWinnerSection)}
                />
              </UpdateTitle>
              {showWinnerSection && (
                <>
                  <WinnerStatusBody>
                    <WinnerStatusTitle>Winner :</WinnerStatusTitle>
                    <WinnerValue>
                      {ticketState?.isWinner ? "True" : "False"}
                    </WinnerValue>
                  </WinnerStatusBody>
                  {ticketState.isWinner ? (
                    <WinnerStatusBody>
                      <WinnerStatusTitle>Ticket Number :</WinnerStatusTitle>
                      <WinnerValue>{ticket}</WinnerValue>
                    </WinnerStatusBody>
                  ) : (
                    <>
                      <FormBody>{AuctionWinnerView}</FormBody>
                    </>
                  )}

                  <WinnerFormBody>
                    {!ticketState.isWinner ? (
                      <Button
                        title={"Select"}
                        btnSize={ButtonSize.md}
                        btnVariant={ButtonVariant.primaryFilled}
                        clicked={setLotteryWinner}
                      />
                    ) : (
                      <Button
                        title={"Clear"}
                        btnSize={ButtonSize.md}
                        btnVariant={ButtonVariant.secondary}
                        clicked={clearLotteryWinnerHandler}
                      />
                    )}
                  </WinnerFormBody>
                </>
              )}
            </FormWrapper>
          )}
        </CreateLotterySecondSection>
      </FormContainer>
      <ActionBtn>
        {detailResponse?.auctionStatus === "U" ? (
          <>
            <Button
              title={"Delete"}
              btnSize={ButtonSize.md}
              btnVariant={ButtonVariant.secondary}
              clicked={deleteAuctionDetails}
            />
            {/* <Button
              title={"Cancel"}
              btnSize={ButtonSize.md}
              btnVariant={ButtonVariant.primaryFilled}
              clicked={triggerCancelAuctionModel}
            /> */}
            <Button
              title={"Update"}
              btnSize={ButtonSize.md}
              btnVariant={ButtonVariant.primaryFilled}
              clicked={validateForm}
            />
          </>
        ) : detailResponse?.auctionStatus === "C" ? (
          <>
            <Button
              title={"Cancel Auction"}
              btnSize={ButtonSize.md}
              btnVariant={ButtonVariant.primaryFilled}
              clicked={triggerCancelAuctionModel}
            />
          </>
        ) : (
          <></>
        )}
      </ActionBtn>
    </Fragment>
  );
};

export default CreateAuction;
